// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc101963","239":"360a3ed3","455":"b244fcf9"}[chunkId] + ".chunk.js";
};